module.exports = __webpack_public_path__ + "static/news4-3-08bb33f2ec20edc54246fa060460eaf5.jpg";